import React from "react";
import TrustCenter from "./misc/TrustCenter";
import PageLayout from "../../../components/Layout/PageLayout";

const TrustCenterScreen: React.FC = () => {
  return (
    <PageLayout>
      <div className="w-full">
        <TrustCenter />
      </div>
    </PageLayout>
  );
};

export default TrustCenterScreen;
